import { useQuery } from '@tanstack/react-query';
import { StaticsApi } from '@/api/statics';

export const useGetStaticsAdmin = () => {
  const { isLoading, isError, data, error, refetch } = useQuery({
    queryKey: ['StaticsApi.getStaticsAdmin'],
    queryFn: StaticsApi.getStaticsAdmin,
    select: (res) => res.data
  });

  return {
    isLoading,
    isError,
    data,
    error,
    refetch
  };
};
